<template>
    <div class="page" id="proProfile">
        <header class="pageHeader rounded">
            <fade-image class="darken" src="assets/headers/profile.png" />
        </header>

        <div class="scroller2 green_dark" v-if="clubs">
            <header>
                <h2>{{ clubs[0].owner.first_name }} {{ clubs[0].owner.last_name }}</h2>

                <ul class="links">
                    <li>
                        <a
                            style="color: white"
                            class="cancel"
                            @click.prevent="$router.back()"
                            href="#"
                        >
                            <x-icon class="icon" />
                        </a>
                    </li>
                </ul>
            </header>

            <ul class="clubs">
                <li v-for="club in clubs" :key="club.id">
                    <span class="club">{{ club.club }}</span>
                    <span class="model">{{ club.name }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import FadeImage from "@/components/App/fade-image";
import { XIcon } from "vue-feather-icons";
export default {
    name: "player-pro-bag",
    components: { XIcon, FadeImage },
    created() {
        this.getBag();
    },
    data() {
        return {
            clubs: false,
        };
    },
    methods: {
        getBag() {
            window.axios.get("/bags/" + this.$route.params.id).then((response) => {
                this.clubs = response.data;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
ul.clubs {
    li {
        padding: 12px 0px;
        color: #fff;
        border-bottom: 1px solid #444745;
        position: relative;
        background: #267962;
        font-weight: 200;
        span {
            &:first-of-type {
                width: 30%;
            }
            &:last-of-type {
                width: 70%;
            }
            display: inline-block;
        }
    }
}
</style>
